import React from "react";
import {
    Box,
    Flex
} from "@chakra-ui/react";

import "../styles/textflex.css";


export default function Gallery(props) {
    const { ...rest } = props;

    return (
        <section className={"content"} {...rest}>
            <Flex className={"container"}>
                <Flex className={"column-wrapper"} direction={{ "base": "column", "md": "row" }}>
                    {props.children}
                </Flex>
            </Flex>
        </section>
    );
}

